<template>
     <div style="width:1300px;margin:0 auto;margin-top:80px;">
         <div class="card page mb-5 p-2" style="width:1300px;margin:0 auto;box-shadow: 10px 10px 5px #888888;" id="v-content">
             <p>
                  <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                  </span>
             </p>
          <div>
               <button :class="{active_kan:kanMeeting==1}" @click="ChangeMeettop(1)" class="btn btn-primary mr-3">
                    已审核会议
               </button>
               <button :class="{active_kan:kanMeeting==0}" @click="ChangeMeettop(0)" class="btn btn-primary">
                    未审核会议
               </button>
                
          </div>
          <div style="margin-top:20px;margin-bottom:50px;">
            <ul>
            <li v-for="(item,index) of list" :key="index">
                <div class="title" :class="{'bgcolor':item.showpage}" @click="ClerkGetBlog(item.id,item.showpage,index)">
                      <p>
                        <span :class="{'zicolor':item.showpage}">
                         {{item.topname}}
                        </span>
                       <span class="numbers" v-show="item.cot!=0">({{item.cot}})</span>
                        <button v-show="item.showpage" class="btn btn-danger btnwei" @click="GetAddMeettop(index,item.id)">
                            修改 
                        </button>
                      </p>  
                    </div>
                     <div v-show="item.showpage">
                          <transition v-for="(item,index) of list1" :key="index" name="slide">
                          <div class="content">
                              <div>
                                  <p>
                                  {{item.title}}
                                  <span class="numbers" v-show="item.cot!=null">
                                     ({{item.cot}}) 
                                  </span>
                                  <span v-show="item.isfinshed==1" class="ml-5">
                                     ({{item.isfinshed | changeState}}) 
                                  </span> 
                                   <span class="btnwei1">
                                      <button v-show="item.state!=1&&(item.cot===0||item.cot==null)" class="btn btn-danger mb-2" @click="change(item.id,item.title)">
                                          修改
                                      </button> 
                                      <!-- <button v-show="item.cot==0||item.cot==null" class="btn btn-danger mb-2" @click="modificationBlog(item.id)">
                                          删除
                                      </button> -->
                                      <button class="btn btn-primary mb-2" @click="goMeeting(item.id)">
                                          查看
                                      </button>
                                      <button v-show="kanMeeting==0" @click="ClerkUpBlog(item.id)" class="btn btn-primary mb-2">
                                          审核
                                      </button>
                                       <button class="btn btn-primary mb-2" @click="revert(item.id)">
                                           回复
                                      </button>
                                   </span>
                                  </p> 
                              </div>
                          </div>
                          </transition>
                     </div>
            </li>

            </ul>
        </div>

             <div class="modal fade" id="myModal1" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content" style="width:500px;height:200px;position:relative;top:300px;left:200px;margin-bottom:50px;">
                                <div class="modal-body" style="font-size:20px;">
                                      
                                       <div style="width:300px;margin:0 auto; text-align:center;margin-bottom:30px;margin-top:30px;color:green;">
                                          <p>
                                             修改会议标题
                                          </p>
                                           <input type="text" placeholder="请输入会议主标题" class="form-control font" v-model="meettop">
                                       </div>
                                      
                                      <div style="text-align:right;">
                                              <button type="button" class="btn btn-primary" data-dismiss="modal" @click="AddMeettop()" :disabled="isDisable"><span aria-hidden="true"></span>确定</button>
                                              <button type="button" class="btn btn-info ml-3" data-dismiss="modal"><span aria-hidden="true"></span>取消</button>
                                      </div>
                               </div>
                            </div>
                        </div>
                    </div>
                </div>
     </div>
</template>
<script>
import { async } from 'q';
export default {
    data(){
        return{
             list:[],
             list1:[],
             showpage:false,   
             state:"",
             meettop:"",
             isDisable:false,
             id:"",
             zhutitle:"",
             kanMeeting:"1"
        }
    },
    components:{
      
    },
     filters:{
      changeState:function(State){
           if(State==0){
             return "未完成"
           }
           else if(State==1){
             return "已完成"
           }
      },
      changeState1:function(state){
          if(state==1){
              return　"已审阅"
          }
          else if(state==0){
            return "未审阅"
          }
      }
    },
    methods:{
         revert(id){
            this.$router.push({path:'/revert',query:{id:id}})
       },
          //审核会议
          ClerkUpBlog:async function(id){
               const { data: res } = await this.$http.post('Dls/getFun', {
                 action: 'ClerkUpBlog',
               obj: JSON.stringify({
                    lxs:'14',
                    logid:id
                  })
                })
              if(res.isok){
                  alert(res.data.msg)
              }
          },

        //改变主标题

         ChangeMeettop(kanMeeting){
              this.kanMeeting=kanMeeting
              this.GetMeettop()
         },
       //修改会议
       change(id,title){
            this.$router.push({path: '/changeMeeting', query:{id:id,zhutitle:this.zhutitle,xiaotitle:title}})
       },
       //删除会议
       modificationBlog:async function(id){
          const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkUpBlog',
          obj: JSON.stringify({
                lxs:'4',
                state:'3',
                id,
          })
        })
     //    console.log(res)
        if (res.isok) {
             if(res.data.isok){
               this.$message.success(res.data.msg)
                  this.getBlog(1,this.state)
                  const obj = res.data
             }
        }
       },
           //查看会议
            goMeeting(id){

            this.$router.push({path: '/lookMeeting', query:{id:id,zhutitle:this.zhutitle}})
       },
         
           //修改主标题
             GetAddMeettop(index,id){
                  $('#myModal1').modal();
                  this.meettop=this.list[index].topname;
                  this.id=id;
             },
             AddMeettop:async function(){
               const { data: res } = await this.$http.post('Dls/AddMeettop', {
                      lx:2,
                      meettop:this.meettop,
                      meettopid:this.id,
                 })
                  if(res.isok){
                  alert(res.message)
                }
                  
            },
            //获取会议主标题
            GetMeettop:async function(){
               
                 const {data: res} = await this.$http.post("http://hyapi.hyey.cn/Dls/GetMeettopcot",{
                        state:this.kanMeeting
                      })
                const that =this
                that.list=res.data;
                that.list.forEach(item=>{
                  item.showpage=false
                })
                // console.log(that.list);

            },
            //获取小标题
           ClerkGetBlog: async function (id,showpage,index) {
          const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkGetBlog',
          obj: JSON.stringify({
              collect:4,
              meettop:id,
			  state: this.kanMeeting
          })
        })
        // console.log(res)
        
        if (res.isok) {
            const that=this
          const obj = res.data
          that.list1=obj.rows2
          that.zhutitle = that.list[index].topname
          that.list.forEach(item => {
          if (item.showpage !== that.list[index].showpage) {
            item.showpage = false;
          }
          });
           that.list[index].showpage = !showpage     
        }
      },
      //添加会议
       addMeeting(){
            this.$router.push({path: '/addMeeting'})
       }
    },
    created(){
        this.GetMeettop()
    }
}
</script>
<style scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #ddeded;
  cursor: pointer;
  padding-left:20px;
}
.btnwei{
  float:right;
  margin-top:5.5px;
  margin-right:5.5px;
}
.btnwei1{
  float: right;
  margin-right:5.5px;
}
.zicolor{
  color:#ccc
}
.tianhui{
  margin-left:600px;
}
.bgcolor{ 
  background-image: linear-gradient(-225deg, #22E1FF 0%, #1D8FE1 48%, #625EB1 100%);
}
.content {
  background: #dddddd;
  height: 50px;
  line-height: 50px;
  border: 1px solid #ddeded;
  color: red;
  padding-left:40px;
}
.numbers{
    color:blue;
}
.active_kan{
     color:red;
}
/* 定义进入过渡的开始状态。在元素被插入之前生效，在元素被插入之后的下一帧移除。也就是说dom刚渲染所执行的动画。 */
.slide-enter {
  max-height: 0px;
}
/* 定义进入过渡生效时的状态。在整个进入过渡的阶段中应用，在元素被插入之前生效，在过渡/动画完成之后移除。这个类可以被用来定义进入过渡的过程时间，延迟和曲线函数。 */
.slide-enter-active {
  transition: all 0.1s ease;
}
/*  2.1.8版及以上 定义进入过渡的结束状态。在元素被插入之后下一帧生效 (与此同时 v-enter 被移除)，在过渡/动画完成之后移除。 */
.slide-enter-to {
  max-height: 1000px;
}
 
/* 定义离开过渡的开始状态。在离开过渡被触发时立刻生效，下一帧被移除。 */
.slide-leave {
  max-height: 1000px;
}
/* 定义离开过渡生效时的状态。在整个离开过渡的阶段中应用，在离开过渡被触发时立刻生效，在过渡/动画完成之后移除。这个类可以被用来定义离开过渡的过程时间，延迟和曲线函数。 */
.slide-leave-active {
  transition: all 0.1s ease;
}
/*  2.1.8版及以上 定义离开过渡的结束状态。在离开过渡被触发之后下一帧生效 (与此同时 v-leave 被删除)，在过渡/动画完成之后移除。 */
.slide-leave-to {
  max-height: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Meeting/CheckMeeting.vue